export default __webpack_public_path__ + "static/media/d2.6c0209e0.svg";